var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{ref:"chart",staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.chart_options}})
}
var staticRenderFns = []

export { render, staticRenderFns }